import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	compareOrderChanges,
	selectBookingApplicationMod,
	selectOrderBookingData,
	selectOrderDetail,
	setInitialBookingData,
	useOrderState,
} from 'entities/orders';
import { selectHallmapSelectedTables } from 'entities/hallmap';
import { isArrayEquals } from 'shared/lib/core';
import { useEffect, useMemo, useRef, useState } from 'react';
import { OrderBookingData } from 'entities/orders/model/types';

export const useBookingReadyCheck = () => {
	const bookingData = useAppSelector(selectOrderBookingData);
	const orderDetail = useAppSelector(selectOrderDetail);
	const selectedResources = useAppSelector(selectHallmapSelectedTables);
	const { isWaitingList } = useOrderState(orderDetail);
	const order = useAppSelector(selectOrderDetail);
	const appMod = useAppSelector(selectBookingApplicationMod);
  const dispatch = useAppDispatch();

	const prevBookingDataIsLoaded = useRef(false);
	const [prevBookingData, setPrevBookingData] = useState<OrderBookingData>();

	useEffect(() => {
		if (
			bookingData.dt_start &&
			bookingData.duration &&
			bookingData.participants_count &&
			!prevBookingDataIsLoaded.current
		) {
			setPrevBookingData(bookingData);
      dispatch(setInitialBookingData());
			prevBookingDataIsLoaded.current = true;
		}
	}, [bookingData, dispatch]);

	const requireBook =
		(prevBookingData &&
			bookingData &&
			!compareOrderChanges(prevBookingData, bookingData)) ||
		!isArrayEquals(
			selectedResources.map(table => table.id),
			orderDetail?.appointment?.resources.map(table => table.id) || [],
		);

	const resourcesCompare = useMemo(() => {
		if (selectedResources && order?.appointment?.resources) {
			return isArrayEquals(
				selectedResources.map(table => table.id),
				order?.appointment?.resources.map(table => table.id) || [],
			);
		}

		return true;
	}, [selectedResources, order]);

	const readyBookingCheck = (waiting?: boolean) => {
		const isReady =
			(requireBook || !selectedResources.length);
		if (waiting !== undefined) {
			return isReady && waiting;
		}
		return isReady;
	};

	const readySaveCheck = () => {
		return (
			(compareOrderChanges(prevBookingData, bookingData) &&
				(isWaitingList ? !resourcesCompare : resourcesCompare)) ||
			appMod
		);
	};

	const readySaveOrBookingCheck = () => {
		return (
			compareOrderChanges(prevBookingData, bookingData) &&
			((isWaitingList ? !resourcesCompare : resourcesCompare))
		);
	};

	return {
		readyBookingCheck,
		readySaveCheck,
		readySaveOrBookingCheck,
		requireBook,
		resourcesCompare,
	};
};
